// hooks/useError.ts
import { message } from "antd";

export const useError = () => {
  const [messageApi, contextHolder] = message.useMessage();

  const showError = (texto: string | undefined | null) => {
    messageApi.open({
      type: "error",
      content: texto,
      key: "error",
    });
  };

  return { showError, contextHolder };
};
